<template>
    <div class="administrative-units-map">
        <map-card
            title="Rwandan Administrative Units"
            :config="mapConfig">
            <template slot="body">

                <div class="row">
                    <div v-for="(type, idx) in unitTypes" :key="idx" class="col-12 col-sm-6 col-md-4">
                        <div class="form-group">
                            <label :for="type.name" class="form-label">{{ type.label }}</label>
                            <v-select
                                :name="type.name"
                                label="name"
                                :options="getUnitList([type.name])"
                                placeholder="All"
                                v-model="selected[type.name]"
                                />
                        </div>
                    </div>
                </div>

            </template>
        </map-card>
    </div>
</template>

<script>
import MapCard from './MapCard';
import GeoJSON from 'ol/format/geojson';

export default {
    components: {
        'map-card': MapCard,
    },

    props: {
        administrativeUnits: {
            type: Object,
            required: true,
        },
        filteredAdministrativeUnits: {
            type: Object,
            default: () => {},
        },
    },

    data() {
        return {
            unitTypes: [
                { label: 'Province', name: 'province' },
                { label: 'District', name: 'district' },
                { label: 'Sector', name: 'sector' },
                { label: 'Cell', name: 'cell' },
                { label: 'Village', name: 'village' },
            ],
            selected: {
                province: null,
                district: null,
                sector: null,
                cell: null,
                village: null,
            },
        };
    },

    watch: {
        selected: {
            handler() {
                this.updateFilteredList();
            },
            deep: true,
        },
    },

    computed: {
        province() {
            return this.filterUnits('province');
        },

        district() {
            return this.filterUnits('district', 'province');
        },

        sector() {
            return this.filterUnits('sector', 'district');
        },

        cell() {
            return this.filterUnits('cell', 'sector');
        },

        village() {
            return this.filterUnits('village', 'cell');
        },
        mapConfig() {
            return {
                height: '400px',
                // layers: this.unitTypes.map(type => {
                //     return {
                //         name: type.label,
                //         url: `${APP_URL}/administrative-unit/spatial/${type.name}`,
                //         format: new GeoJSON(),
                //     };
                // }),
                layers: [
                    {
                        name: 'simple cells',
                        url: `${APP_URL}/administrative-unit/spatial/cell`,
                        format: new GeoJSON(),
                    },
                ],
            };
        },
    },

    mounted() {
        this.updateFilteredList();
    },

    methods: {
        getUnitList(unitType) {
            return this[unitType];
        },

        filterUnits(currentKey, upperKey = null) {
            // if currentKey = 'province', `${currentKey}s` = 'provinces'
            return this.administrativeUnits[`${currentKey}s`].filter(current => {
                if (this.selected[currentKey] !== null) {
                    return current.id === this.selected[currentKey].id;
                }

                if (upperKey !== null) {
                    return this[upperKey].map(u => u.id).indexOf(current[`${upperKey}_id`]) > -1;
                }

                return true;
            });
        },

        updateFilteredList() {
            this.filteredAdministrativeUnits.province = this.province;
            this.filteredAdministrativeUnits.district = this.district;
            this.filteredAdministrativeUnits.sector = this.sector;
            this.filteredAdministrativeUnits.cell = this.cell;
            this.filteredAdministrativeUnits.village = this.village;
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/maps/AdministrativeUnitsMap.vue